import uuid from '../../video-data/utils/uuid';
import { createMigration } from './utils';

export const migrationTo9_209 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        const hasTimeAwareMediaAsset = scene
            .get('children')
            .some((child) => child.get('classType') === 'TimeAwareMediaAsset');

        if (!hasTimeAwareMediaAsset) {
            return scene;
        }

        const hasColorAtBottom = scene.getIn(['children', 0, 'classType']) === 'ColorAsset';
        if (hasColorAtBottom) {
            return scene;
        }

        const nextColorAssetIndex = (() => {
            const hasColorAssets = scene
                .get('children')
                .some((child) => child.get('classType') === 'ColorAsset');

            if (!hasColorAssets) {
                return 1;
            }

            const maxNumber = scene.get('children')
                .filter(item => item.get('classType') === 'ColorAsset')
                .map(item => item.get('name'))
                .map(name => parseInt(name.match(/\d+/)[0], 10)) // Step 3: Extract the integer from the name
                .max();

            return maxNumber + 1;
        })();

        const colorName = `color_${nextColorAssetIndex}`;
        const blankColorAsset = {
            'classType': 'ColorAsset',
            'id': uuid(),
            'name': colorName,
            'sourceColor': 'themeRef_colors_0',
            'sourceAlpha': 1,
            'parentId': null,
            'animationConfig': [],
            'objectAnimation': [],
            'colorGraphics': [],
            'alphaGraphics': [],
            'animateOutBehaviour': 'never',
            'transformation': {
                'position': {
                    'x': 0,
                    'y': 0,
                },
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'rotation': 0,
            },
            'filters': [],
            'isEditable': false,
            'isColorEditable': false,
            'introAnimationOffset': 0,
            'outroAnimationOffset': 0,
            'mask': null,
        };

        return scene.withMutations(map => {
            const children = map.get('children');
            const updatedChildren = children.unshift(blankColorAsset);

            map.set('children', updatedChildren);
        });
    },
});
